// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"851":"css/app.7072","3733":"css/admin-app.7072"}[chunkId] + ".css";
};